import styled from "styled-components";

import checkmark from "../../../../image/checkmark.svg";

const StyledContainer = styled.div`
  align-items: center;
  display: flex;
  gap: 24px;

  .ant-btn.ant-btn-round.ant-btn {
    background: #e9e9e9;
    height: 32px;
    width: 32px;
  }

  .palette {
    border: 1px solid #c1c1c1;
    border-radius: 12px;
    display: flex;
    padding: 16px;

    .item {
      border-radius: 50%;
      filter: drop-shadow(3px 0px 3px rgba(0, 0, 0, 0.25));
      height: 42px;
      width: 42px;
    }
  }

  span {
    color: #1e1919;
    font-size: 16px;
    font-weight: 500;
  }

  &.active {
    .ant-btn.ant-btn-round.ant-btn {
      background: #019a00;
      position: relative;

      &::before {
        content: "";
        background: url(${checkmark}) no-repeat;
        height: 10px;
        position: absolute;
        width: 14px;
      }
    }
  }
`;

export default StyledContainer;
